import { ChangeDetectorRef, Component, HostBinding, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { PageFormComponent } from '../../features/customer/page-form/page-form.component';
import { RoleType } from '../../shared/enums/role-type/role-type.module';
import { AuthService } from '../../services/auth/auth.service';
import { LoadingService } from '../../services/loading/loading.service';
import { UtilsService } from '../../services/shared/utils/utils.service';
import { AppStateService } from '../../services/shared/app-state/app-state.service';

@Component({
  selector: 'app-customer-layout',
  templateUrl: './customer-layout.component.html',
  styleUrl: './customer-layout.component.css'
})
export class CustomerLayoutComponent implements OnInit {
  showPreviewBadge = false;
  manager: string | undefined = "";
  hasUnfinishedPages: boolean = false;
  userRole: string = "";
  roleType: RoleType = RoleType.CUSTOMER;
  customerId: string = "";
  isPreview: boolean = false;
  isLoading = false;
  isEmbed: boolean = false;
  @HostBinding('class.isEmbed') addClass = this.appState.getIsEmbed();
  @ViewChild(RouterOutlet) outlet!: RouterOutlet;
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private loadingService: LoadingService,
    private appState: AppStateService
  ) {
    this.loadingService.loading$.subscribe(state => {
      this.isLoading = state;
    });
  }

  ngOnInit(): void {

    this.isEmbed = this.appState.getIsEmbed();

    this.router.events.subscribe(() => {
      this.checkPreviewInUrl();
    });

    this.route.firstChild?.paramMap.subscribe(params => {
      this.customerId = params.get('customerId') ?? "";
    });

    this.isPreview = this.appState.getIsPreview();
    if(this.isPreview){
       this.route.queryParams.subscribe(queryParams => {
        this.roleType = queryParams['role'];
         this.userRole = this.roleType != RoleType.CUSTOMER ? RoleType[this.roleType] : "";
       });
    }
    else{
      this.authService.loadUserRole()
      this.authService.getUserRoleNotAsync().subscribe(_roleType => {
        if (_roleType !== null) {
          this.roleType = _roleType;
          this.userRole = this.roleType != RoleType.CUSTOMER ? RoleType[this.roleType] : "";
        }
      });
    }
  }

  ngAfterViewChecked() {
    const activeComponent = this.outlet.component;
    if (activeComponent instanceof PageFormComponent && activeComponent.customer) {
      this.manager = activeComponent.customer.manager;
      this.hasUnfinishedPages = activeComponent.hasUnfinishedPages;
      this.cdr.detectChanges();
    }
  }

  goToAdminPages() {
    if (this.roleType == RoleType.ADMIN) {
      window.open('/admin/pages', '_blank');
    }
  }

  openMenu(): void {
    // const sidenav = document.querySelector('.customer-container mat-sidenav.sidenav') as HTMLElement;
    const activeComponent = this.outlet.component;
    if (activeComponent instanceof PageFormComponent) {
      activeComponent.openMenu();
    }
    // sidenav.classList.remove('closed')
    // sidenav.classList.add('opened')
  }
  checkPreviewInUrl(): void {
    setTimeout(() => {
      this.showPreviewBadge = this.router.url.includes('/preview');
    });
  }
}
